import { UserState } from '@frontend/user/types';

import { UserStateBadgeProps } from './user-state-badge.component';

interface ViewProps {
    displayName: React.ReactNode;
    type: string;
}

export const useUserStateBadge = (props: UserStateBadgeProps): ViewProps => {
    return {
        displayName: UserState.getByValue(props.state)?.displayName || 'Unknown',
        type: UserState.getType(props.state)
    };
};
